import React from "react";

function InputGroup (props) {

    const btn = props.buttonStyle !== undefined;

    return (
        <div className="form-group">
            <div className="row">
                <div className="col-sm-4">
                    <label htmlFor={props.name} style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }} >
                        {props.label}
                    </label>
                </div>
                <div className="col-sm-8">
                    {props.children}
                    <div className="input-group inline">
                        <input
                            className="form-control"
                            id={props.name}
                            maxLength={props.maxLength}
                            name={props.name}
                            noValidate={!props.required}
                            onChange={props.onChange}
                            placeholder={props.placeHolder}
                            required={Boolean(props.required)}
                            type="text"
                            value={props.value}
                        />
                        <div className="input-group-append">
                            {
                                btn ? <button
                                    className={`btn btn-${props.buttonStyle}`}
                                    onClick={props.onClick}
                                    type="button"
                                      >
                                    {props.append}
                                      </button>
                                    : <span className="input-group-text">
                                        {props.append}
                                    </span>
                            }
                        </div>
                        <div className="invalid-feedback">
                            {props.validationMsg}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default InputGroup;
